import { motion } from "framer-motion";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { COMPANY } from "@/data";

export default function Contact() {
  const items = [
    { icon: Phone, label: "Call 24×7", value: COMPANY.phone, href: `tel:${COMPANY.phoneRaw}`, testid: "contact-phone" },
    { icon: Phone, label: "Call 24×7", value: COMPANY.phone2, href: `tel:${COMPANY.phone2Raw}`, testid: "contact-phone-2" },
    { icon: Mail, label: "Email", value: COMPANY.email, href: `mailto:${COMPANY.email}`, testid: "contact-email" },
    { icon: Mail, label: "Email", value: COMPANY.email2, href: `mailto:${COMPANY.email2}`, testid: "contact-email-2" },
    { icon: MapPin, label: "Office", value: COMPANY.address, href: null, testid: "contact-address" },
    { icon: Clock, label: "Hours", value: COMPANY.hours, href: null, testid: "contact-hours" },
  ];

  return (
    <section data-testid="contact" id="contact" className="bg-background text-foreground py-28 md:py-40">
      <div className="mx-auto max-w-[1600px] px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-16 border-t border-black/15 pt-6"
        >
          <span className="font-mono-accent text-xs uppercase tracking-[0.25em] text-primary">
            /05 — Contact
          </span>
          <h2 className="font-display mt-6 text-4xl md:text-6xl tracking-tighter">
            Mira Bhayandar plant. <span className="text-signal-yellow">Always open.</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 border-l border-t border-black/15">
            {items.map((it) => {
              const Inner = (
                <>
                  <it.icon size={22} className="text-primary mb-6" />
                  <p className="font-mono-accent text-xs uppercase tracking-[0.2em] text-muted-foreground mb-2">
                    {it.label}
                  </p>
                  <p className="text-lg leading-relaxed">{it.value}</p>
                </>
              );
              return it.href ? (
                <a key={it.testid} data-testid={it.testid} href={it.href} className="border-r border-b border-black/15 p-8 hover:bg-black hover:text-[#F5F4EF] transition-colors block">
                  {Inner}
                </a>
              ) : (
                <div key={it.testid} data-testid={it.testid} className="border-r border-b border-black/15 p-8">
                  {Inner}
                </div>
              );
            })}
          </div>

          <div className="border border-black/15 overflow-hidden min-h-[360px]">
            <iframe
              data-testid="contact-map"
              title="Rich Global RMC Location"
              src="https://www.google.com/maps?q=Ghodbunder+Road+Mira+Bhayandar+Mumbai&output=embed"
              className="w-full h-full min-h-[360px] grayscale"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
